export default __webpack_public_path__ + "static/media/games-video.e089cb43.mp4";